import React from "react";
import styles from "./UserData.module.sass";
import Input from "../ui/Form/Input/Input";
import Button from "../ui/Button/Button";
import Title from "../Title/Title";
import masks from "../../utils/masks";
import validation from "../../utils/validation";
import { identifierType } from "../../components/IdentificationChooser/IdentificationChooser";

class UserData extends React.Component {
  targetDiv = React.createRef();

  state = {
    value: "",
    isValid: true
  };

  validate = (value = this.state.value) => {
    const validateFunc =
      value.length <= 11
        ? validation.cpf
        : validation.cnpj;
    if (validateFunc(value)) {
      this.props.onChange(value);
      this.setState({
        isValid: true
      });
    } else {
      this.props.onChange(null);
      this.setState({
        isValid: false
      });
    }
    this.props.selectedIdentifierChange(value.length <= 11
      ? identifierType.CPF
      : identifierType.CNPJ);
  };

  componentDidMount() {
    if (this.props.document) {
      this.setState({
        value: this.props.document.replace(/\D/g, "")
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.selectedIdentifier !== this.props.selectedIdentifier) {
      this.setState({
        value: "",
        isValid: true
      });
    }
    if (this.props.ibc && prevState.value !== this.state.value) {
      this.validate();
    }
  }

  scrollToDiv = () => {
    this.targetDiv.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  render() {
    return (
      <div
        ref={el => (this.targetDiv = el)}
        className={styles.userDataContainer}
      >
        <Title
          title={
            "Digite seu CPF ou CNPJ"
          }
        />

        <div className={styles.userDataContent}>
          <Input
            errorMsg={
              this.state.value.length <= 11
                ? "CPF inválido"
                : "CNPJ inválido"
            }
            isValid={this.state.isValid}
            typeDocument={this.props.selectedIdentifier}
            onChange={value =>
              this.setState({ value: value, resetInput: false })
            }
            maxLength={18}
            value={this.state.value}
            mask={
              this.state.value.length <= 11 ? masks.cpf : masks.cnpj
            }
            onKeyPress={event => {
              return !this.props.ibc && (event.key === "Enter" && this.validate());
            }}
            readonly={this.props.ibc}
          />
          {!this.props.ibc && (
            <Button onClick={() => this.validate()}>Confirmar</Button>
          )}
        </div>
      </div>
    );
  }
}

export default UserData;
